import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Certification from "./pages/Certification";
import About from "./pages/About";
import Resources from "./pages/Resources";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Stats from "./pages/Stats";
import AdminPanel from "./pages/AdminPanel";
import NewsArticle from "./pages/NewsArticle";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/certificacion" element={<Certification />} />
          <Route path="/acerca" element={<About />} />
          <Route path="/recursos" element={<Resources />} />
          <Route path="/noticias" element={<News />} />
          <Route path="/noticias/:id" element={<NewsArticle />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppButton />
    </div>
  );
}

export default App;